<template>
    <div class="cookies-app">
    <div class="cookies-modal" v-if="show_modal">
        <header>
            {{ message }}
        </header>
        <div class="buttons">
            <button class="w25" @click="validate_all">Tout accepter</button>
            <button class="w25 nobr_mobile" @click="reject_all">Tout refuser</button>
            <button class="w50" v-if="!choices_open" @click="choices_open = !choices_open">{{ !choices_open ? 'Choisir' : 'Fermer les choix' }}</button>
            <button class="w25 bt_mobile" v-if="choices_open" @click="choices_open = !choices_open">Fermer les choix</button>
            <button class="w25 bt_mobile" v-if="choices_open" @click="validate_choices">Valider mes choix</button>
        </div>
        <div class="choices" v-show="choices_open">
            <header>En cochant ces cases, vous acceptez les cookies associés à ces usages :</header>
            <div class="buttons">
                <div class="w50" :class="i === 0 ? 'nobr_mobile' : ''" v-for="(c, k, i) in available_choices">
                    <label><input type="checkbox" v-model="choices[k]" /> {{ c.label }}</label>
                </div>
            </div>
        </div>
    </div>
    <div class="cookies-cta" v-if="!show_modal" @click="show_modal = !show_modal">
<svg
   xmlns:dc="http://purl.org/dc/elements/1.1/"
   xmlns:cc="http://creativecommons.org/ns#"
   xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#"
   xmlns:svg="http://www.w3.org/2000/svg"
   xmlns="http://www.w3.org/2000/svg"
   xmlns:sodipodi="http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd"
   xmlns:inkscape="http://www.inkscape.org/namespaces/inkscape"
   version="1.1"
   x="0px"
   y="0px"
   viewBox="0 0 32.00024 31.987499"
   xml:space="preserve"
   id="svg30"
   sodipodi:docname="cookie.svg"
   width="32.00024"
   height="31.987499"
   inkscape:version="1.0.1 (3bc2e813f5, 2020-09-07)"><metadata
     id="metadata36"><rdf:RDF><cc:Work
         rdf:about=""><dc:format>image/svg+xml</dc:format><dc:type
           rdf:resource="http://purl.org/dc/dcmitype/StillImage" /><dc:title></dc:title></cc:Work></rdf:RDF></metadata><defs
     id="defs34" /><sodipodi:namedview
     pagecolor="#ffffff"
     bordercolor="#666666"
     borderopacity="1"
     objecttolerance="10"
     gridtolerance="10"
     guidetolerance="10"
     inkscape:pageopacity="0"
     inkscape:pageshadow="2"
     inkscape:window-width="1920"
     inkscape:window-height="1017"
     id="namedview32"
     showgrid="false"
     fit-margin-top="0"
     fit-margin-left="0"
     fit-margin-right="0"
     fit-margin-bottom="0"
     inkscape:zoom="13.45"
     inkscape:cx="16.00024"
     inkscape:cy="19.9875"
     inkscape:window-x="-8"
     inkscape:window-y="-8"
     inkscape:window-maximized="1"
     inkscape:current-layer="svg30" /><path
     d="m 16.00024,31.9875 c -4.34,0 -8.4020001,-1.7 -11.4380001,-4.786 -3.012,-3.062 -4.63100001,-7.109 -4.56000001,-11.397 0.004,-0.225 0.083,-0.442 0.226,-0.617 0.136,-0.166 0.333,-0.298 0.541,-0.351 1.30700001,-0.33 2.41400001,-1.211 3.03600001,-2.419 0.232,-0.452 0.766,-0.658 1.243,-0.477 3.229,1.223 6.3720001,-1.25 6.3720001,-4.391 0,-0.102 -0.016,-0.199 -0.029,-0.297 l -0.027,-0.21 c -0.03,-0.277 0.056,-0.553 0.238,-0.764 0.182,-0.211 0.444,-0.335 0.722,-0.345 2.118,-0.072 3.936,-1.555 4.42,-3.605 0.3,-1.263 1.598,-2.044 2.91,-1.741 v 0 c 7.269,1.691 12.346,8.058 12.346,15.485 0,8.775 -7.178,15.915 -16,15.915 z M 2.0072399,16.5395 c 0.115,3.485 1.513,6.751 3.98,9.26 2.658,2.701 6.2130001,4.188 10.0130001,4.188 7.72,0 14,-6.242 14,-13.915 0,-6.492 -4.44,-12.058 -10.799,-13.536 -0.224,-0.052 -0.467,0.069 -0.511,0.253 -0.611,2.588 -2.71,4.542 -5.275,5.029 -0.142,3.575 -3.095,6.44 -6.7050001,6.44 -0.519,0 -1.042,-0.066 -1.564,-0.196 -0.772,1.127 -1.868,1.991 -3.139,2.477 z"
     id="path2"
     style="fill:#ffffff;fill-opacity:1" /><path
     d="m 12.00024,1.9875 c -0.26,0 -0.52,-0.11 -0.71,-0.29 -0.18,-0.19 -0.29,-0.45 -0.29,-0.71 0,-0.26 0.11,-0.52 0.29,-0.71 0.38,-0.37 1.05,-0.37 1.42,0 0.18,0.19 0.29,0.44 0.29,0.71 0,0.26 -0.11,0.52 -0.29,0.71 -0.19,0.18 -0.45,0.29 -0.71,0.29 z"
     id="path4"
     style="fill:#ffffff;fill-opacity:1" /><path
     d="m 26.00024,18.9875 c -0.26,0 -0.521,-0.11 -0.71,-0.29 -0.181,-0.19 -0.29,-0.45 -0.29,-0.71 0,-0.26 0.109,-0.521 0.29,-0.71 0.38,-0.37 1.04,-0.37 1.42,0 0.189,0.189 0.29,0.45 0.29,0.71 0,0.26 -0.11,0.52 -0.29,0.71 -0.19,0.18 -0.45,0.29 -0.71,0.29 z"
     id="path6"
     style="fill:#ffffff;fill-opacity:1" /><path
     d="m 22.00024,15.9875 c -0.26,0 -0.521,-0.11 -0.71,-0.29 -0.181,-0.19 -0.29,-0.45 -0.29,-0.71 0,-0.26 0.109,-0.52 0.29,-0.71 0.37,-0.37 1.05,-0.37 1.42,0 0.18,0.19 0.29,0.45 0.29,0.71 0,0.26 -0.11,0.52 -0.29,0.71 -0.19,0.18 -0.45,0.29 -0.71,0.29 z"
     id="path8"
     style="fill:#ffffff;fill-opacity:1" /><path
     d="m 15.00024,14.9875 c -0.26,0 -0.52,-0.11 -0.71,-0.29 -0.18,-0.19 -0.29,-0.45 -0.29,-0.71 0,-0.26 0.11,-0.52 0.29,-0.71 0.38,-0.37 1.05,-0.37 1.42,0 0.18,0.19 0.29,0.45 0.29,0.71 0,0.26 -0.11,0.52 -0.29,0.71 -0.19,0.18 -0.45,0.29 -0.71,0.29 z"
     id="path10"
     style="fill:#ffffff;fill-opacity:1" /><path
     d="m 15.00024,19.9875 c -0.26,0 -0.52,-0.11 -0.71,-0.29 -0.18,-0.19 -0.29,-0.45 -0.29,-0.71 0,-0.26 0.11,-0.521 0.29,-0.71 0.38,-0.37 1.04,-0.37 1.42,0 0.18,0.189 0.29,0.439 0.29,0.71 0,0.27 -0.11,0.52 -0.29,0.71 -0.19,0.18 -0.45,0.29 -0.71,0.29 z"
     id="path12"
     style="fill:#ffffff;fill-opacity:1" /><path
     d="m 12.00024,25.9875 c -0.26,0 -0.52,-0.11 -0.71,-0.29 -0.18,-0.19 -0.29,-0.45 -0.29,-0.71 0,-0.26 0.11,-0.521 0.29,-0.71 0.37,-0.37 1.05,-0.37 1.42,0 0.18,0.189 0.29,0.45 0.29,0.71 0,0.26 -0.11,0.52 -0.29,0.71 -0.19,0.18 -0.44,0.29 -0.71,0.29 z"
     id="path14"
     style="fill:#ffffff;fill-opacity:1" /><circle
     cx="5.5002398"
     cy="7.4875002"
     r="1.5"
     id="circle16"
     style="fill:#ffffff;fill-opacity:1" /><circle
     cx="20.50024"
     cy="9.4875002"
     r="1.5"
     id="circle18"
     style="fill:#ffffff;fill-opacity:1" /><circle
     cx="19.50024"
     cy="23.487499"
     r="1.5"
     id="circle20"
     style="fill:#ffffff;fill-opacity:1" /><circle
     cx="8.5002403"
     cy="18.487499"
     r="1.5"
     id="circle22"
     style="fill:#ffffff;fill-opacity:1" /></svg>
    </div>
    </div>
</template>

<script>
    const get_cookie_pref = (key, available_choices) => {
        const cookie_map = document.cookie.split(/;\s/).map(a => a.split('=')).reduce((out, a) => {
            out[a[0].trim()] = a.slice(1).join("=");
            return out;
        }, {});
        try {
            return JSON.parse(cookie_map[key]);
        } catch(e) {
            return {
                made_choice: 0,
                choices: {
                    ...Object.keys(available_choices).reduce((o, i) => {
                        o[i] = 0;
                        return o;
                    }, {}),
                },
            }; 
        }
    };

    const save_cookie_pref = (key, val) => {
        document.cookie = `${key}=${JSON.stringify(val)};path=/;max-age=${60*60*24*30}`;
    };

    export default {
        props: {
            message: {
                type: String,
            },
            available_choices: {},
            cookies_key: {
                type: String,
            },
        },
        data() {
            const prefs = get_cookie_pref(this.cookies_key, this.available_choices);
            return {
                show_modal: !prefs.made_choice,
                choices_open: 0,
                ...prefs,
            };
        },
        computed: {
            choices_keys() {
                return Object.keys(this.available_choices);
            },
        },
        methods: {
            after_update(old_choices) {
                this.choices_keys.forEach(k => {
                    if (this.choices[k]) {
                        this.available_choices[k].ok_fn();
                    }
                });
                if (!this.show_modal) {
                    const msg = document.querySelector('.urgent-msg');
                    if (!msg) return;
                    const hash = msg.getAttribute('data-hash');
                    if(!window.localStorage.getItem('techne-sasg-' + hash)) {
                        msg.classList.add('display');
                    }
                }
                if (!old_choices) return;
                /** If a pref was set from ON to OFF, reload the page to unload the rejected choice */
                const flag = this.choices_keys.reduce((o, i) => (o || (old_choices[i] && !this.choices[i])), false);
                if (flag) {
                    window.location.reload();
                }
            },
            get_old_choices() {
                return this.choices_keys.reduce((o, i) => {
                    o[i] = this.choices[i];
                    return o;
                }, {});
            },
            validate_all() {
                const old_choices = this.get_old_choices();
                this.show_modal = 0;
                this.choices_keys.forEach(k => {
                    this.choices[k] = 1;
                });
                save_cookie_pref(this.cookies_key, {
                    made_choice: 1, choices: {...this.choices}
                });
                this.after_update(old_choices);
            },
            reject_all() {
                this.show_modal = 0;
                this.choices_keys.forEach(k => {
                    this.choices[k] = 0;
                });
                save_cookie_pref(this.cookies_key, {
                    made_choice: 1, choices: {...this.choices}
                });
                this.after_update(old_choices);
            },
            validate_choices() {
                this.show_modal = 0;
                save_cookie_pref(this.cookies_key, {
                    made_choice: 1, choices: {...this.choices}
                });
                this.after_update(old_choices);
            },
        },
        mounted() {
            this.after_update();
        }
    };
</script>

<style lang="scss">
    
</style>